import { render, staticRenderFns } from "./StoryAdminBar.vue?vue&type=template&id=688a4ab3"
import script from "./StoryAdminBar.vue?vue&type=script&lang=js"
export * from "./StoryAdminBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports